module.exports = __webpack_public_path__ + "img/CancelSucefull.6acae780.svg";